const ARCHITECTURE_BANNER_DEFAULT =
  'https://i.ibb.co/1QbG6Wv/Bannerweb-europa-v5.jpg';
const ARCHITECTURAL_FINISHES_BANNER_DEFAULT =
  'https://i.ibb.co/zNHdfWx/Banner-web-europa-v3.jpg';
const AUTOMOTIVE_BANNER_DEFAULT =
  'https://i.postimg.cc/hPPn92JY/Banner-Dubai-v4.jpg';

const architectureBanners = {
  ar: 'https://i.ibb.co/sbyHzhT/IMG-2741.jpg',
  br: 'https://i.ibb.co/C9dXqL2/IMG-2738.jpg',
};

const architecturalFinishesBanners = {
  ar: 'https://i.ibb.co/sbyHzhT/IMG-2741.jpg',
  br: 'https://i.ibb.co/C9dXqL2/IMG-2738.jpg',
};

const automotiveBanners = {
  ar: 'https://i.ibb.co/sbyHzhT/IMG-2741.jpg',
  br: 'https://i.ibb.co/C9dXqL2/IMG-2738.jpg',
};

const normalizeLocale = (locale = '') => locale.toLowerCase().split('-')[0];

export const getArchitectureBanner = (locale) =>
  architectureBanners[normalizeLocale(locale)] || ARCHITECTURE_BANNER_DEFAULT;

export const getArchitecturalFinishesBanner = (locale) =>
  architecturalFinishesBanners[normalizeLocale(locale)] ||
  ARCHITECTURAL_FINISHES_BANNER_DEFAULT;

export const getAutomotiveBanner = (locale) =>
  automotiveBanners[normalizeLocale(locale)] || AUTOMOTIVE_BANNER_DEFAULT;
